import {
  apiClient,
} from "./apiClient";

import type {
  CancelGoodsReceiptInput,
  CreateGoodsReceiptInput,
  GoodsReceiptItemData,
  GoodsReceiptsPageData,
  GoodsReceiptsQuery,
  UpdateGoodsReceiptInput,
} from "../types/goods-receipts.types";

function buildQueryString(
  query:
    GoodsReceiptsQuery = {},
): string {
  const params =
    new URLSearchParams();

  if (query.search?.trim()) {
    params.set(
      "search",
      query.search.trim(),
    );
  }

  if (
    query.purchaseOrderId
  ) {
    params.set(
      "purchaseOrderId",
      query.purchaseOrderId,
    );
  }

  if (query.supplierId) {
    params.set(
      "supplierId",
      query.supplierId,
    );
  }

  if (query.warehouseId) {
    params.set(
      "warehouseId",
      query.warehouseId,
    );
  }

  if (query.status) {
    params.set(
      "status",
      query.status,
    );
  }

  if (query.fromDate) {
    params.set(
      "fromDate",
      query.fromDate,
    );
  }

  if (query.toDate) {
    params.set(
      "toDate",
      query.toDate,
    );
  }

  if (query.sort) {
    params.set(
      "sort",
      query.sort,
    );
  }

  if (query.cursor) {
    params.set(
      "cursor",
      query.cursor,
    );
  }

  if (
    query.limit !==
    undefined
  ) {
    params.set(
      "limit",
      String(
        query.limit,
      ),
    );
  }

  const queryString =
    params.toString();

  return queryString
    ? `?${queryString}`
    : "";
}

export const goodsReceiptsApi = {
  list(
    query:
      GoodsReceiptsQuery = {},
  ) {
    return apiClient.get<
      GoodsReceiptsPageData
    >(
      `/goods-receipts${buildQueryString(
        query,
      )}`,
    );
  },

  getById(
    goodsReceiptId: string,
  ) {
    return apiClient.get<
      GoodsReceiptItemData
    >(
      `/goods-receipts/${encodeURIComponent(
        goodsReceiptId,
      )}`,
    );
  },

  create(
    input:
      CreateGoodsReceiptInput,
  ) {
    return apiClient.post<
      GoodsReceiptItemData
    >(
      "/goods-receipts",
      input,
    );
  },

  update(
    goodsReceiptId: string,

    input:
      UpdateGoodsReceiptInput,
  ) {
    return apiClient.patch<
      GoodsReceiptItemData
    >(
      `/goods-receipts/${encodeURIComponent(
        goodsReceiptId,
      )}`,
      input,
    );
  },

  post(
    goodsReceiptId: string,
  ) {
    return apiClient.post<
      GoodsReceiptItemData
    >(
      `/goods-receipts/${encodeURIComponent(
        goodsReceiptId,
      )}/post`,
      {},
    );
  },

  cancel(
    goodsReceiptId: string,

    input:
      CancelGoodsReceiptInput,
  ) {
    return apiClient.post<
      GoodsReceiptItemData
    >(
      `/goods-receipts/${encodeURIComponent(
        goodsReceiptId,
      )}/cancel`,
      input,
    );
  },
};